import React from "react"

import TakeMyMoney from "./assets/TakeMyMoney"

import { contacts } from "../../../../pages-data/_V2/common/contacts"
import styles from "./styles.module.scss"

export const consultationForm = {
	icon: <TakeMyMoney className={styles.icon} />,
	subheading: "время принять решение",
	heading: "Хочу открыть свой бизнес!",
	phone: contacts.phone,
	btn: "Заказать звонок",
}
